import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Communication extends Icon {
  render() {
    let { color, size, style, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        style={style}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
      >
        <g fill={color}>
          <path d="M3.5,16l-1.3-0.5v-5.4C0.8,9,0,7.4,0,5.6C0,2.5,2.5,0,5.6,0h5.8C14.5,0,17,2.5,17,5.6c0,3.1-2.5,5.6-5.6,5.6   H8.3L3.5,16z M5.6,1.5c-2.3,0-4.1,1.8-4.1,4.1C1.5,7,2.2,8.3,3.4,9l0.3,0.6v4l3.8-3.8L8,9.7h3.4c2.3,0,4.1-1.8,4.1-4.1 c0-2.3-1.8-4.1-4.1-4.1H5.6z" />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Communication.js